import styled from 'styled-components';
import { ReactNode } from 'react';

interface ISliderWrapperProps {
  leftShift?: number;
  $peek?: 'none' | 'both' | 'left' | 'right';
  extraWidth?: number;
  parent?: 'cardCarousel' | 'contentSlider' | 'categorySubcategory';
  children?: ReactNode;
  className?: string;
}

export const SliderWrapper = styled.div<ISliderWrapperProps>`
  position: relative;
  z-index: 10;
  ${({ parent }: ISliderWrapperProps) =>
    parent === 'cardCarousel' &&
    `
  .slick-list {
    padding-left: 1.7rem;
    margin-left: 1.5rem;
    @media (min-width: 481px) {
      padding-left: 0;
      margin-left: -6rem;
    }
    @media (min-width: 1025px) {
      padding-left: 0;
      margin-left: 0;
    }
  }`}
  &.feature-slider {
    padding-right: 0;
    margin-right: 0;
    overflow: hidden;
    .slick-track {
      left: 3vw;
    }
    .slick-initialized {
      .slick-slide {
        padding: 0 0 50px 10px;
      }
    }
    @media screen and (max-width: 480px) {
      .slick-track {
        left: 0;
      }
    }
  }
  &.sub-category {
    .subcategory-card {
      padding-right: 20px;
    }
    @media screen and (max-width: 479px) {
      padding: 4%;
      .subcategory-card {
        padding: 0 10px;
      }
    }
  }

  &.subcategory-slider {
    .slick-track {
      float: left;
    }
  }
  &.card-carousel {
    .slick-initialized .slick-slide {
      padding-left: 10px;
      padding-right: 10px;
      @media screen and (min-width: 768px) {
        padding-left: 0px;
        padding-right: 0px;
      }
    }
  }
  @media screen and (min-width: 480px) {
    ${({ $peek = 'none' }) =>
      $peek !== 'none' &&
      `
    overflow: hidden;
    margin-left: ${$peek === 'both' || $peek === 'left' ? '-50px' : '0'};
    padding-left: ${$peek === 'both' || $peek === 'left' ? '50px' : '1'};
    margin-right: ${$peek === 'both' || $peek === 'right' ? '-30px' : '0'};
    padding-right: ${$peek === 'both' || $peek === 'right' ? '30px' : '1'};
    .slick-list { overflow: visible; }

    ${({ extraWidth }: ISliderWrapperProps) => extraWidth && `width: calc(100% + ${extraWidth}px);`}
  `};
  }

  // Limit the slider to just 5 dots
  /* hiding all bullets by default */
  .slick-dots li {
    display: none;
  }
  /* only displaying the active bullets */
  .slick-dots li.slick-active {
    display: inline-block;
  }
  /* displaying the first 5 bullets when slick-active class isn't applied to any li before them  */
  .slick-dots li:nth-child(1),
  .slick-dots li:nth-child(2),
  .slick-dots li:nth-child(3),
  .slick-dots li:nth-child(4) {
    display: inline-block;
  }
  /* hiding the first 5 bullets if slick-active exist before them */
  .slick-dots li.slick-active ~ li:nth-child(1),
  .slick-dots li.slick-active ~ li:nth-child(2),
  .slick-dots li.slick-active ~ li:nth-child(3),
  .slick-dots li.slick-active ~ li:nth-child(4),
  .slick-dots li.slick-active ~ li:nth-child(5) {
    display: none;
  }
  /* specific conditions to always display the first 5 bullets */
  .slick-dots li.slick-active + li:nth-child(5),
  .slick-dots li.slick-active + li:nth-child(4),
  .slick-dots li.slick-active + li:nth-child(3),
  .slick-dots li.slick-active + li:nth-child(2),
  .slick-dots li.slick-active + li:nth-child(1),
  .slick-dots li.slick-active + li + li:nth-child(5),
  .slick-dots li.slick-active + li + li:nth-child(4),
  .slick-dots li.slick-active + li + li:nth-child(3),
  .slick-dots li.slick-active + li + li:nth-child(2),
  .slick-dots li.slick-active + li + li:nth-child(1),
  .slick-dots li.slick-active + li + li + li:nth-child(5),
  .slick-dots li.slick-active + li + li + li:nth-child(4),
  .slick-dots li.slick-active + li + li + li:nth-child(3),
  .slick-dots li.slick-active + li + li + li:nth-child(2),
  .slick-dots li.slick-active + li + li + li:nth-child(1),
  .slick-dots li.slick-active + li + li + li + li:nth-child(5),
  .slick-dots li.slick-active + li + li + li + li:nth-child(4),
  .slick-dots li.slick-active + li + li + li + li:nth-child(3),
  .slick-dots li.slick-active + li + li + li + li:nth-child(2),
  .slick-dots li.slick-active + li + li + li + li:nth-child(1) {
    display: inline-block;
  }

  .slick-initialized .slick-slide {
    padding: 0 0 50px;
  }

  .slick-dots {
    ${({ parent }: ISliderWrapperProps) =>
      parent === 'cardCarousel'
        ? `
    margin-top: 20px;
    margin-bottom: 30px;
    bottom: -20px;
    @media (min-width: 768px) {
      margin-top: 40px;
      margin-bottom: 44px;
      bottom: -50px;
    }
    `
        : `bottom: 15px;
      @media (min-width: 768px) {
        bottom: -5px;
      }`}

    left: 0;

    li {
      width: 10px;
      button {
        width: 10px;
        &:before {
          width: 10px;
          font-size: 8px;
          color: #5a5e5a;
          opacity: 0.5;
        }
      }
      &:first-child,
      &:last-child {
        button:before {
          font-size: 6px;
        }
      }
      &.slick-active button:before {
        font-size: 10px;
        opacity: 1;
      }
    }
  }

  .slick-track {
    ${({ leftShift = 0 }) => leftShift && `margin-left: ${leftShift}px;`}

    @media screen and (max-width: 480px) {
      margin-left: 0;
    }
  }

  .slick-arrow {
    cursor: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='30' cy='30' r='30' transform='rotate(90 30 30)' fill='%23010E54'/%3E%3Cpath d='M38.6738 29.6883C38.6738 29.6883 27.9939 29.6883 22.1738 29.6883M22.1738 29.6883C24.8351 29.6883 28.0287 32.1755 28.0287 34.9385M22.1738 29.6883C24.8351 29.6883 28.0287 27.2016 28.0287 24.4385' stroke='white' stroke-linecap='square'/%3E%3Cpath d='M52.8837 28.0751C53.6529 29.2431 53.6529 30.7569 52.8837 31.9249L51.3506 34.253C50.8172 35.0631 50.5597 36.0238 50.6167 36.9921L50.7803 39.7748C50.8625 41.1709 50.1056 42.4819 48.8554 43.1089L46.3637 44.3585C45.4967 44.7933 44.7933 45.4967 44.3585 46.3637L43.1089 48.8554C42.4819 50.1056 41.171 50.8625 39.7748 50.7803L36.9921 50.6167C36.0238 50.5597 35.0631 50.8172 34.253 51.3506L31.9249 52.8837C30.7569 53.6529 29.2431 53.6529 28.0751 52.8837L25.747 51.3506C24.9369 50.8172 23.9762 50.5597 23.0079 50.6167L20.2252 50.7803C18.8291 50.8625 17.5181 50.1056 16.8911 48.8554L15.6415 46.3637C15.2067 45.4967 14.5033 44.7933 13.6363 44.3585L11.1446 43.1089C9.89445 42.4819 9.13755 41.171 9.21966 39.7748L9.38331 36.9921C9.44026 36.0238 9.18282 35.0631 8.64937 34.253L7.11629 31.9249C6.34711 30.7569 6.34711 29.2431 7.11629 28.0751L8.64937 25.747C9.18282 24.9369 9.44026 23.9762 9.38331 23.0079L9.21966 20.2252C9.13755 18.8291 9.89445 17.5181 11.1446 16.8911L13.6363 15.6415C14.5033 15.2067 15.2067 14.5033 15.6415 13.6363L16.8911 11.1446C17.5181 9.89445 18.8291 9.13755 20.2252 9.21966L23.0079 9.38331C23.9762 9.44026 24.9369 9.18282 25.747 8.64937L28.0751 7.11629C29.2431 6.34711 30.7569 6.34711 31.9249 7.11629L34.253 8.64937C35.0631 9.18282 36.0238 9.44026 36.9921 9.38331L39.7748 9.21966C41.1709 9.13755 42.4819 9.89445 43.1089 11.1446L44.3585 13.6363C44.7933 14.5033 45.4967 15.2067 46.3637 15.6415L48.8554 16.8911C50.1056 17.5181 50.8625 18.8291 50.7803 20.2252L50.6167 23.0079C50.5597 23.9762 50.8172 24.9369 51.3506 25.747L52.8837 28.0751Z' stroke='white' stroke-linejoin='round'/%3E%3C/svg%3E")
        32 32,
      pointer;
    height: 100%;
    z-index: 1;
    width: 100px;
    opacity: 0;
    &:hover {
      opacity: 1;
      transition: opacity 0.5s;
    }
    &.slick-disabled {
      opacity: 0;
    }
    &:before {
      content: '';
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-size: contain;
      display: inline-block;
    }
    &.slick-prev {
      left: 0;
      text-align: left;
      ::before {
        transform: rotate(90deg);
        left: 0;
      }
      &.slick-disabled {
        cursor: none;
      }
    }
    &.slick-next {
      cursor: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle r='30' transform='matrix(-7.54979e-08 1 1 7.54979e-08 30 30)' fill='%23010E54'/%3E%3Cpath d='M21.3262 29.6883C21.3262 29.6883 32.0061 29.6883 37.8262 29.6883M37.8262 29.6883C35.1649 29.6883 31.9713 32.1755 31.9713 34.9385M37.8262 29.6883C35.1649 29.6883 31.9713 27.2016 31.9713 24.4385' stroke='white' stroke-linecap='square'/%3E%3Cpath d='M7.11629 28.0751C6.34711 29.2431 6.34711 30.7569 7.11628 31.9249L8.64936 34.253C9.18282 35.0631 9.44025 36.0238 9.38331 36.9921L9.21965 39.7748C9.13754 41.1709 9.89445 42.4819 11.1446 43.1089L13.6363 44.3585C14.5033 44.7933 15.2067 45.4967 15.6415 46.3637L16.8911 48.8554C17.5181 50.1056 18.829 50.8625 20.2252 50.7803L23.0079 50.6167C23.9762 50.5597 24.9369 50.8172 25.747 51.3506L28.0751 52.8837C29.2431 53.6529 30.7569 53.6529 31.9249 52.8837L34.253 51.3506C35.0631 50.8172 36.0238 50.5597 36.9921 50.6167L39.7748 50.7803C41.1709 50.8625 42.4819 50.1056 43.1089 48.8554L44.3585 46.3637C44.7933 45.4967 45.4967 44.7933 46.3637 44.3585L48.8554 43.1089C50.1055 42.4819 50.8625 41.171 50.7803 39.7748L50.6167 36.9921C50.5597 36.0238 50.8172 35.0631 51.3506 34.253L52.8837 31.9249C53.6529 30.7569 53.6529 29.2431 52.8837 28.0751L51.3506 25.747C50.8172 24.9369 50.5597 23.9762 50.6167 23.0079L50.7803 20.2252C50.8625 18.8291 50.1056 17.5181 48.8554 16.8911L46.3637 15.6415C45.4967 15.2067 44.7933 14.5033 44.3585 13.6363L43.1089 11.1446C42.4819 9.89445 41.1709 9.13755 39.7748 9.21966L36.9921 9.38331C36.0238 9.44026 35.0631 9.18282 34.253 8.64937L31.9249 7.11629C30.7569 6.34711 29.2431 6.34711 28.0751 7.11629L25.747 8.64937C24.9369 9.18282 23.9762 9.44026 23.0079 9.38331L20.2252 9.21966C18.8291 9.13755 17.5181 9.89445 16.8911 11.1446L15.6415 13.6363C15.2067 14.5033 14.5033 15.2067 13.6363 15.6415L11.1446 16.8911C9.89445 17.5181 9.13755 18.8291 9.21965 20.2252L9.38331 23.0079C9.44025 23.9762 9.18282 24.9369 8.64936 25.747L7.11629 28.0751Z' stroke='white' stroke-linejoin='round'/%3E%3C/svg%3E%0A")
          32 32,
        pointer;
      right: 0;
      text-align: right;
      ::before {
        transform: rotate(-90deg);
        right: 0;
      }
      &.slick-disabled {
        cursor: none;
      }
    }
  }

  @media (min-width: 768px) {
    .slick-slider {
      margin-right: -1.25rem;
    }
  }
`;
